import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import InsertImageIcon from './icons/insert-media.svg';
import InsertMediaCommand from './insertmediacommand';


export default class InsertMediaUI extends Plugin {
  init() {
    const editor = this.editor;
    const t = editor.t;
    this.editor.commands.add('insertmedia', new InsertMediaCommand(editor));
    editor.ui.componentFactory.add('insertmedia', locale => {
      const view = new ButtonView(locale);
      view.set({
        label: t('Insert media file'),
        tooltip: true,
        withText: false,
        icon: InsertImageIcon
      });

      const command = editor.commands.get('insertmedia');
      view.bind('isEnabled').to(command);

      this.listenTo(view, 'execute', () => {
        editor.execute('insertmedia');
        editor.editing.view.focus();
      });

      return view;
    });

  }
}

